module.exports = __webpack_public_path__ + "img/b5-4.0383fc2.png";